<template>
    <div class="card-house card-plot" :style="objectStyle" ref="houseCard">
        <div v-if="card && Object.keys(card).length" class="card-house__wrapper">
            <div class="card-house__image-wrapper">

                <img v-if="card.id === 'southeast'" class="card-house__image"  
                :src="`${getURL()}/${require('@/assets/img/Map/kv-8-11.jpg')}`" :srcset="`
                        ${getURL()}/${require('@/assets/img/Map/kv-8-11@2x.jpg')} 2x,
                        ${getURL()}/${require('@/assets/img/Map/kv-8-11@3x.jpg')} 3x
                    `" 
                :alt="card.title" />

                <img v-if="card.id === 'southwest'" class="card-house__image"
                    :src="`${getURL()}/${require('@/assets/img/Map/kv-8-11.jpg')}`" :srcset="`
                        ${getURL()}/${require('@/assets/img/Map/kv-8-11@2x.jpg')} 2x,
                        ${getURL()}/${require('@/assets/img/Map/kv-8-11@3x.jpg')} 3x
                    `" :alt="card.title" />

                <img v-if="card.id === 'northeast'" class="card-house__image" :src="`${getURL()}/${require('@/assets/img/Map/kv-1.jpg')}`"
                    :srcset="`
                        ${getURL()}/${require('@/assets/img/Map/kv-1@2x.jpg')} 2x,
                        ${getURL()}/${require('@/assets/img/Map/kv-1@3x.jpg')} 3x
                    `" :alt="card.title" />

            </div>
            <div class="card-house__body">
                <h2 class="card-house__body-title">
                    {{ card.title }}
                </h2>
                <ul class="card-house__body-list" v-if="card.params && Object.keys(card.params).length">
                    <li class="card-house__body-list-item">
                        <p v-if="!card.withHouse" class="card-house__body-list-item-label">
                            Всего участков
                        </p>
                        <p v-else class="card-house__body-list-item-label">
                            Всего домов
                        </p>
                        <p class="card-house__body-list-item-value">
                            {{ card.params.count }}
                        </p>
                    </li>
                    <li class="card-house__body-list-item">
                        <p class="card-house__body-list-item-label">Свободно</p>
                        <p class="card-house__body-list-item-value">
                            {{ card.params.isFreeCount }}
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <div class="card-house__void" v-else>
            <p>Нет данных</p>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { getURL } from '@/helpers/routeHelpers';

const houseCard = ref<HTMLElement | null>(null);

const statusCardPlotShow = computed(() => {
    return cardSettingsStore.STATUS_CARD_PLOT_ZONE_SHOW;
});

const objectStyle = computed(() => {
    let left = position.value.width / 2 + position.value.left;

    if (houseCard.value && houseCard.value instanceof Element) {
        const widthCard = houseCard.value.clientWidth;

        left = left - widthCard / 2;
    }

    return {
        left: `${left}px`,
        bottom: `calc(100% - ${position.value.bottom - position.value.topMap
            }px + ${position.value.height / 2}px)`,
        opacity: statusCardPlotShow.value ? '1' : '0',
    };
});

const card = computed(() => {
    return landPlotStore.LAND_PLOT_CARD_ZONE;
});

const position = computed(() => {
    return cardSettingsStore.POSITION_CARD_PLOT_ZONE;
});
</script>

<style lang="less"></style>
